import { z } from 'zod';

export const deleteCropResponseSchema = z.object({
  deleted: z.boolean(),
});

export type IDeleteCropResponse = z.infer<typeof deleteCropResponseSchema>;
